import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { MAIN_SITE_URL } from '@/mocks/categories';

export default function Hero() {
  const { t } = useTranslation();

  return (
    <section className="relative overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=A%20bright%20airy%20flat%20lay%20of%20assorted%20streetwear%20clothing%20sneakers%20caps%20and%20a%20canvas%20tote%20bag%20arranged%20on%20a%20soft%20warm%20cream%20background%2C%20sage%20green%20and%20beige%20pastel%20tones%2C%20soft%20natural%20daylight%2C%20editorial%20product%20photography%2C%20clean%20minimal%20composition%20with%20generous%20negative%20space%2C%20high%20detail&width=1600&height=900&seq=usfans-hero-new-02&orientation=landscape"
          alt="USFans Spreadsheet product categories"
          className="h-full w-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/45"></div>
      </div>

      <div className="relative mx-auto flex w-full max-w-7xl flex-col items-center px-4 py-20 text-center md:px-6 md:py-28">
        <span className="inline-flex items-center gap-2 rounded-full border border-background-50/30 bg-background-50/10 px-4 py-1.5 text-xs font-semibold text-background-50 backdrop-blur md:text-sm">
          <span className="flex h-3.5 w-3.5 items-center justify-center">
            <i className="ri-shield-check-line"></i>
          </span>
          {t('hero.badge')}
        </span>

        <h1 className="mt-6 max-w-3xl font-heading text-3xl font-bold leading-tight text-background-50 md:text-5xl">
          {t('hero.title')}
        </h1>

        <p className="mt-5 max-w-2xl text-sm leading-relaxed text-background-100/90 md:text-lg">
          {t('hero.subtitle')}
        </p>

        <div className="mt-8 flex flex-col items-center gap-3 sm:flex-row">
          <a
            href={MAIN_SITE_URL}
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 rounded-full bg-primary-500 px-6 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600 md:text-base whitespace-nowrap"
          >
            {t('hero.ctaPrimary')}
            <span className="flex h-4 w-4 items-center justify-center">
              <i className="ri-arrow-right-up-line"></i>
            </span>
          </a>
          <a
            href={MAIN_SITE_URL}
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 rounded-full bg-accent-500 px-6 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-accent-600 md:text-base whitespace-nowrap"
          >
            {t('hero.ctaSecondary')}
            <span className="flex h-4 w-4 items-center justify-center">
              <i className="ri-shopping-cart-line"></i>
            </span>
          </a>
        </div>

        <Link
          to="/article/usfans-spreadsheet-guide"
          className="mt-5 inline-flex items-center gap-2 text-sm font-semibold text-background-50 underline-offset-4 hover:underline md:text-base"
        >
          {t('hero.ctaGuide')}
          <span className="flex h-4 w-4 items-center justify-center">
            <i className="ri-arrow-right-line"></i>
          </span>
        </Link>

        <p className="mt-8 text-xs text-background-100/80 md:text-sm">{t('hero.trust')}</p>
      </div>
    </section>
  );
}